import { useEffect, useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@karma/components';
import { useSelector } from 'react-redux';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import { categoriesSelector, selectedCategoriesSelector } from 'store/giftCards/selectors';
import useAction from 'hooks/useAction';
import { selectCategories } from 'store/giftCards/actions';
import { ResolutionTypeContext } from 'contexts/ResolutionTypeContext';
import { Categories, Category } from './ModalBodyGiftCardsCategories.style';

const ModalBodyGiftCardsCategories = ({ closeModal }) => {
  const { isPhoneResolution } = useContext(ResolutionTypeContext);
  const categories = useSelector(categoriesSelector);
  const currentSelectedCategories = useSelector(selectedCategoriesSelector);
  const [selectedCategories, setSelectedCategories] = useState(currentSelectedCategories);
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const selectCategoriesFunc = useAction(selectCategories);
  const selectedCategoriesRef = useRef(selectedCategories);

  const toggleCategory = category => {
    const newSelectedCategories = selectedCategories.filter(
      selectedCategory => selectedCategory.code !== category.code,
    );

    if (newSelectedCategories.length === selectedCategories.length) {
      newSelectedCategories.push(category);
    }

    setSelectedCategories(newSelectedCategories);
  };

  useEffect(() => {
    selectedCategoriesRef.current = selectedCategories;
  }, [selectedCategories]);

  useEffect(() => {
    return () => {
      selectCategoriesFunc(selectedCategoriesRef.current);
    };
  }, []);

  return (
    <Stack direction="column" alignItems="flex-start">
      <Typography variant="labelLarge" bMargin={isPhoneResolution ? 12 : 20}>
        {t('app:filterCategories')}
      </Typography>
      <Categories>
        {categories.map(category => (
          <Category
            key={category.code}
            role="button"
            onClick={() => toggleCategory(category)}
            $selected={selectedCategories.some(selectedCategory => selectedCategory.code === category.code)}
          >
            <Typography variant="paragraphSmall">
              {category.emoji} {category.name}
            </Typography>
          </Category>
        ))}
      </Categories>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.FILTER}
        size="medium"
        onClick={closeModal}
        fullWidth
        tMargin={isPhoneResolution ? 32 : 20}
      >
        {t('app:filter')}
      </Button>
    </Stack>
  );
};

export default ModalBodyGiftCardsCategories;
